import { ReturnClass, BaseeSearchClass } from 'projects/Shared-Lib/model/search-result';
import { SelectListItem } from '../lib/select/select-property';
import * as t from '../lib/select/select-service';

//search filter request api fields
export class SearchClass extends BaseeSearchClass {
  Keyword?: string;
  EffectiveDate?: string;
  IsEnabled?: number;
  EffectDate?: any;
}

//structure of table for postback api
export class TableSchema {
  BulletinId?: string;
  EffectiveDate?: any;
  ExpiredDate?: any;
  Subject?: string;
  Contents?: string;
  IsEnabled?: any;
  IsDeleted?: boolean;
  CreatedDateTime?: string;
  CreatedBy?: string;
  UpdatedDateTime?: string;
  UpdatedBy?: string;
}


//search page models
export class Bulletin_Search {
  filter: SearchClass;
  ddlEnabled?: SelectListItem[];
  dataResult?: ReturnClass;

  constructor() {
    this.filter = new SearchClass();
    this.filter.Keyword = '';
    this.filter.EffectiveDate = '';
    this.filter.IsEnabled = 2;

    this.ddlEnabled = t.GetItems(t.Items.Options_Enabled, true);
  }

}


//document edit/create page models
export class Bulletin_Document extends TableSchema {
  ddlEnabled?: SelectListItem[];
  //SelectEnabled: any;

  constructor() {
    super();
    this.EffectiveDate = '';
    this.ExpiredDate = '';
    this.Subject = '';
    this.Contents = '';
    this.IsEnabled = 1;
    //this.ddlEnabled = t.GetItems(t.Items.Options_Enabled);
  }

  /**
   * name
   */
  public SetData(obj: any) {    
    this.EffectiveDate = obj.EffectiveDate;
    this.ExpiredDate =  obj.ExpiredDate;
    this.Subject = obj.Subject;
    this.Contents = obj.Contents;
    this.IsEnabled = obj.IsEnabled == true ? 1 : 0;
  }
}
